import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Fog from 'components/bolt/fog/fog';
import { accessNested, joinClasses } from 'utils/utils';
import * as webp from 'utils/bolt/webp';
import { isWebPSupported } from 'utils/isWebPSupported';
import Store from 'store/store';
import s from 'base/bolt/boltApp.sss';
import 'store/customTracking.js';

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);

		this.x = 0;
		this.y = 0;
		this.followX = 0;
		this.followY = 0;
		this.friction = 1 / 30;
		this.parallaxActive = true;

		this.initParallax = this.initParallax.bind(this);
		this.onMouseMove = this.onMouseMove.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.tick = this.tick.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();

		Store.on('SET_ACTIVE_PAGE', this.onPageChange);

		this.setState({ showFog: Store.get().activePage === 'boltHome' });

		this.initParallax();
	}

	componentWillUnmount() {
		super.componentWillUnmount();

		Store.off('SET_ACTIVE_PAGE', this.onPageChange);

		this.destroyParallax();
	}

	initParallax() {
		if (!this.state.appState.client?.isDesktopSize) {
			return;
		}
		document.getElementById('mainScroll').addEventListener('mousemove', this.onMouseMove);
		this.tick();
	}

	destroyParallax() {
		document.getElementById('mainScroll').removeEventListener('mousemove', this.onMouseMove);
		window.cancelAnimationFrame(this.mouseMoveTimer);
	}

	onMouseMove(e) {
		if (!this.parallaxActive) {
			return;
		}

		// const mouseX = Math.max(-100, Math.min(100, window.innerWidth / 2 - e.clientX));
		// const mouseY = Math.max(-100, Math.min(100, window.innerHeight / 2 - e.clientY));
		// this.followX = (20 * mouseX) / 100;
		// this.followY = (10 * mouseY) / 100;
		this.followX = 1 - e.clientX / (window.innerWidth / 2);
		this.followY = 1 - e.clientY / (window.innerHeight / 2);
	}

	onPageChange(page) {
		this.parallaxActive = page === 'boltHome';
		this.setState({ showFog: page === 'boltHome' });
	}

	tick() {
		if (this.$bgVideo && this.parallaxActive) {
			this.x += (this.followX - this.x) * this.friction;
			this.y += (this.followY - this.y) * this.friction;
			this.parallax.style.transform = `translate(calc(-50% + ${this.x * 20}px), calc(-50% - ${this.y * 10}px))`;
		}

		this.mouseMoveTimer = window.requestAnimationFrame(this.tick);
	}

	getExtra() {
		const imageRoot = this.state.appState?.appData?.urls?.roots?.image;
		return this.state.showFog && <Fog imageRoot={imageRoot} />;
	}

	renderBgVideo() {
		const { bgVideo, appState, posterVisible, backgroundStyle } = this.state;
		const { activePage, homeActivePercentage } = appState;
		const isPageDedicatedPage = (activePage !== 'boltHome') && !appState.appData.pages[activePage]?.section;
		const preLoadImg = this.getBgValue('preLoadImg');
		const fallbackFormat = accessNested(Store.get(), 'appData.pages.boltHome.data.bg.alternativeImageFormat', 'jpg');
		const showtimesShowing = accessNested(appState, 'showtimes.show', false);
		const hideBackground = !homeActivePercentage || showtimesShowing || isPageDedicatedPage;
		const accessibilityCopy = accessNested(appState, 'appData.copy.accessibilityCopy', {});

		return (
			<div ref={$ref => this.parallax = $ref} class={joinClasses({ s, bgVideo: true, hideBackground })} key="bgVideo">
				<video
					style={backgroundStyle}
					muted={this.state.audioMuted}
					autoPlay
					playsInline
					loop={!this.getBgValue('disableLoop')}
					poster={isWebPSupported ? preLoadImg : preLoadImg.replace(/\.[^.]*$/, fallbackFormat)}
					onCanPlay={this.playVideo}
					onError={this.removeBgVideo}
					ref={$ref => this.$bgVideo = $ref}
					ariaLabel={accessibilityCopy.$BACKGROUND_VIDEO_ARIA}
				>
					{bgVideo.endsWith('.webm') && <source src={bgVideo} type="video/webm" />}
					<source src={bgVideo.replace(/\.[^./]+$/, '.mp4')} type="video/mp4" />
				</video>
				{posterVisible && <webp.Picture src={preLoadImg} alt="" fallbackFormat={fallbackFormat} />}
			</div>
		);
	}
}
